//replaces barchart.html
import { TrafficGrowthComparison } from "app/components/React/TrafficGrowthComparison/TrafficGrowthComparison";
import type { FC } from "react";
import type { IDashboardWidgetInterface } from "../utils/DashboardWidgetsInterfaces-v2";

export const TrafficGrowthComparisonTemplateV2: FC<IDashboardWidgetInterface> = (props) => {
    const { widget } = props;
    return (
        <TrafficGrowthComparison
            data={widget.data}
            viewData={widget.viewData}
        />
    );
};
